import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { HashRouter, type Route } from '../router.js';
import './home-screen.js';
import '../games/recognize/recognize-game.js';
import '../games/count/count-game.js';
import '../games/add/add-game.js';
import '../games/sub/sub-game.js';

@customElement('app-router')
export class AppRouter extends LitElement {
  private router = new HashRouter();
  @state() private route: Route = 'home';

  override connectedCallback(): void {
    super.connectedCallback();
    this.route = this.router.current;
    this.router.subscribe((r) => {
      this.route = r;
    });
    this.router.start();
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();
    this.router.stop();
  }

  override render() {
    switch (this.route) {
      case 'recognize':
        return html`<recognize-game></recognize-game>`;
      case 'count':
        return html`<count-game></count-game>`;
      case 'add':
        return html`<add-game></add-game>`;
      case 'sub':
        return html`<sub-game></sub-game>`;
      case 'home':
      default:
        return html`<home-screen></home-screen>`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-router': AppRouter;
  }
}
